import { useT } from "@transifex/react"

export const RewardDuration = ({
  rewardDuration,
}: {
  rewardDuration: string | undefined
}) => {
  const t = useT()
  switch (rewardDuration) {
    case "daily":
      return <b>{t("one day")}</b>
    case "three_day":
      return <b>{t("three days")}</b>
    case "weekly":
      return <b>{t("one week")}</b>
    case "monthly":
      return <b>{t("one month")}</b>
    case "two_month":
      return <b>{t("two months")}</b>
    case "three_month":
      return <b>{t("three months")}</b>
    case "six_month":
      return <b>{t("six months")}</b>
    case "yearly":
      return <b>{t("one year")}</b>
    case "lifetime":
      return <b>{t("a lifetime")}</b>
    default:
      return <b>{t("an unknown time")}</b>
  }
}
